<template>
  <div class="modal-msg">
    <h3 class="modal-msg-title">Заявка отправлена</h3>
    <p class="modal-msg-text">
      Мы получили вашу заявку. Наши юристы свяжутся с Вами в ближайшее время <br />
          с одного из следующих номеров:<br />
          8927-730 09 66 Кристина<br />
          8927-730 07 27 Наталья.
    </p>
  </div>
</template>

<script>
export default {
  name: "Thanks",
  mounted() {
    setTimeout(() => {
      this.$store.dispatch("viewOrHideThanks");
    }, 20000);
  },
};
</script>

<style scoped>
.modal-msg {
  z-index: 9999;
}
</style>
